import { createNodeFromContent, type Editor } from "@tiptap/core";

/**
 * Whether `markdown` from the editor is `stored` as this editor would write
 * it. The editor normalizes what it loads (blank lines around blocks, an empty
 * paragraph after a trailing list), so a byte comparison reads opening a note
 * as an edit to it.
 *
 * The parsed JSON goes through the schema the way loading does: the parser
 * emits `1.` as a list item with no children, and serializing that raw JSON
 * throws.
 */
export function isSameMarkdown(editor: Editor, markdown: string, stored: string): boolean {
  if (markdown === stored) return true;
  const manager = editor.markdown;
  if (!manager) return false;
  const loaded = createNodeFromContent(manager.parse(stored), editor.schema);
  return markdown.trimEnd() === manager.serialize(loaded.toJSON()).trimEnd();
}
